// extracted by mini-css-extract-plugin
export default {"wrap":"ZF-z","fullWidth":"_F-z","hideOnDesktop":"aG-z","content":"bG-z","hasOpenedNav":"cG-z","crumbsList":"dG-z","dropdownsWrap":"eG-z"};